var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbnailIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 13,
    viewBox: "0 0 17 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 6H0V0H5V6ZM5 13H0V7H5V13ZM6 13H11V7H6V13ZM17 13H12V7H17V13ZM6 6H11V0H6V6ZM12 6V0H17V6H12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnailIcon);
export default __webpack_public_path__ + "static/media/ThumbnailIcon.d24bab44.svg";
export { ForwardRef as ReactComponent };